var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostureWalking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3043 5.98741C13.5423 5.98741 14.546 4.98374 14.546 3.74566C14.546 2.50757 13.5423 1.50391 12.3043 1.50391C11.0662 1.50391 10.0625 2.50757 10.0625 3.74566C10.0625 4.98374 11.0662 5.98741 12.3043 5.98741Z",
    fill: "#0D212C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5899 6.75H11.9746C13.1226 6.75 14.0533 7.68069 14.0533 8.82875V12.5338C14.0533 13.005 14.2405 13.4569 14.5736 13.7901L16.0085 15.2249C16.5213 15.7378 16.8786 16.3852 17.0391 17.0925L18.0017 21.3342C18.0951 21.9475 17.6204 22.5 17 22.5C16.544 22.5 16.1441 22.1954 16.0231 21.7557L14.5462 17.7075L10.838 14.6712C10.2446 14.1852 9.91326 13.4492 9.94297 12.6827L10.0533 9.83663L8.73044 10.9075L8.28876 13.138C8.18497 13.6621 7.67451 14.0017 7.15098 13.8949C6.64576 13.7919 6.3112 13.3093 6.39187 12.8001L6.797 10.2426C6.889 9.6618 7.20524 9.14028 7.67773 8.7902L9.50027 7.4398C10.1049 6.99182 10.8374 6.75 11.5899 6.75Z",
    fill: "#0D212C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.9538 12.5489C17.794 13.0683 17.2226 13.3384 16.7198 13.1321L14.6118 12.4272C14.274 12.2886 14.0534 11.9597 14.0534 11.5946L12.9036 9.52561L13.0392 7.04297L15.3173 10.2519L17.5602 11.4936C17.9154 11.7155 18.0769 12.1486 17.9538 12.5489Z",
    fill: "#0D212C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.94374 22.2442C7.31615 22.5879 7.89069 22.5862 8.26105 22.2402L10.9866 19.1126C11.3353 18.7124 11.6004 18.2464 11.7663 17.7421L12.7326 14.8033L9.94296 12.6836L9.57118 17.0895L6.86189 20.9071C6.52654 21.3027 6.56263 21.8924 6.94374 22.2442Z",
    fill: "#0D212C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostureWalking);
export default __webpack_public_path__ + "static/media/PostureWalking.f7386c92905bd3bd1439f5691aec02b9.svg";
export { ForwardRef as ReactComponent };